import { DestroyRef, Injectable, NgZone } from '@angular/core';
import { UserProfileSelectors } from '@gestor-web/@core/store/selectors';
import { Store } from '@ngrx/store';
import { environment } from '@gestor-web/environments/environment';
import posthog from 'posthog-js';
import { Subject, takeUntil, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PosthogScriptService {
  private initialized: boolean = false;
  private identified: boolean = false;
  private ngDestroyed$ = new Subject<void>();

  constructor(
    private ngZone: NgZone,
    private store: Store,
    private destroyRef: DestroyRef,
  ) {
    const unregister = this.destroyRef.onDestroy(() => {
      this.ngDestroyed$.next();
      this.ngDestroyed$.complete();
      unregister();
    });

    this.store
      .select(UserProfileSelectors.selectCookieAcceptAll)
      .pipe(
        takeUntil(this.ngDestroyed$),
        // tap(all => console.log('[Script::PostHog] listening cookie consent:', all)),
      )
      .subscribe(all => {
        if (!this.initialized) {
          this.initPostHog(all);
        } else {
          this.updatePostHog(all);
        }
      });

    this.store
      .select(UserProfileSelectors.selectUserEmail)
      .pipe(
        takeUntil(this.ngDestroyed$),
        tap(email => {
          // console.log('[PostHot] email: ', email);
          if (!!email && !this.identified && this.initialized) {
            this.ngZone.runOutsideAngular(() => {
              const isBlendus = email.endsWith('@blendus.com.br');
              posthog.identify(email, { email, is_blendus: isBlendus });
              this.identified = true;
            });
          }
        }),
      )
      .subscribe();
  }

  private initPostHog(useCookies: boolean) {
    // console.log('[Script::PostHog] initPostHog - useCookies:', useCookies);
    if (!environment.production) {
      return;
    }
    if (this.initialized) {
      // console.log('[Script::PostHog] initPostHog... skipped!');
      return;
    }

    // console.log('[Script::PostHog] initPostHog... initializing!');
    this.ngZone.runOutsideAngular(() => {
      posthog.init(environment.posthogKey, {
        api_host: environment.posthogHost,
        defaults: '2025-05-24',
        debug: false,
        cross_subdomain_cookie: true,
        persistence: useCookies ? 'localStorage+cookie' : 'memory',
      });
    });
    this.initialized = true;
  }

  private updatePostHog(useCookies) {
    // console.log('[Script::PostHog] updatePostHog - useCookies:', useCookies);

    this.ngZone.runOutsideAngular(() => {
      posthog.set_config({
        persistence: useCookies ? 'localStorage+cookie' : 'memory',
      });
    });
  }
}
